import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

const lightbox = new PhotoSwipeLightbox({
    gallery: '#galery-bloc',
    children: 'a',
    showHideAnimationType: 'zoom',
    pswpModule: () => import('photoswipe')
});

lightbox.init();